import { type FC } from "react";

import classNames from "classnames";

import { UiCrossIcon } from "@jti/brand-icons/ui-cross";
import { IconButton } from "@jti/core-components";
import { Price, useTranslations } from "@jti/ui";

import styles from "./CartMiniHeader.module.scss";

export type CartMiniHeaderProps = {
  itemsCount: number;
  hasShadow?: boolean;
  subtotal?: {
    currency: string;
    value: number;
  };
  onClose?: () => void;
  pending?: boolean;
};

export const CartMiniHeader: FC<CartMiniHeaderProps> = ({
  itemsCount,
  hasShadow = false,
  subtotal,
  onClose,
  pending = false,
}) => {
  const { __ } = useTranslations();
  const showSubtotal = itemsCount > 0 && subtotal;

  const headerClasses = classNames(styles.header, { [styles.headerShadow]: hasShadow });

  return (
    <div className={headerClasses}>
      <div className={styles.closeButtonWrapper}>
        <IconButton
          icon={UiCrossIcon}
          onClick={onClose}
          data-testid="modal-close-icon-button"
          aria-label={__("common.close")}
        />
      </div>
      <div className={styles.textSection}>
        <div className={styles.textWrapper}>
          <h6 className={styles.headerText}>{__("cart.cart_mini.title")}</h6>
          {!pending && (
            <span className={styles.headerText} data-testid="miniCartTitleCount">
              ({itemsCount})
            </span>
          )}
        </div>
        {!pending && showSubtotal && (
          <div className={styles.textWrapper}>
            <div className={styles.subHeaderText}>{__("cart.cart_mini.subtotal")}</div>
            <Price className={styles.subHeaderText} price={subtotal} />
          </div>
        )}
      </div>
    </div>
  );
};
